// extracted by mini-css-extract-plugin
export default {"root":"EligibilityExclusionRow_root__rIkps","info":"EligibilityExclusionRow_info__zEK-t"};